module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(parseInt(_vm.$store.state.config.user.level) < 99) ? [_c('tooltip', {
    attrs: {
      "label": "New Ticket",
      "type": "default",
      "placement": "right"
    }
  }, [_c('a', {
    staticClass: "button button-table is-small",
    on: {
      "click": function($event) {
        return _vm.newOccurrence()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  })])]), _vm._v(" "), _c('tooltip', {
    attrs: {
      "label": "Refresh Service",
      "type": "default",
      "placement": "right"
    }
  }, [_c('a', {
    staticClass: "button button-table is-small",
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])]), _vm._v(" "), _c('tooltip', {
    attrs: {
      "label": "View",
      "type": "default",
      "placement": "right"
    }
  }, [_c('a', {
    staticClass: "button button-table is-small",
    on: {
      "click": _vm.url
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })])]), _vm._v(" "), ((_vm.data.status === 'Rejected' || _vm.data.our_status === 'Rejected') && parseInt(_vm.data.reject_check) === 0 && ((parseInt(this.$store.state.config.user.id) === 520) || (parseInt(this.$store.state.config.user.id) === 5) || (parseInt(this.$store.state.config.user.id) === 1842))) ? _c('tooltip', {
    attrs: {
      "label": "Reject Checked",
      "type": "default",
      "placement": "right"
    }
  }, [_c('a', {
    staticClass: "button button-table is-small",
    on: {
      "click": function($event) {
        return _vm.confirmReject()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])]) : _vm._e(), _vm._v(" "), ((_vm.data.status === 'Confirmed') && parseInt(_vm.data.confirmed_check) === 0 && ((parseInt(this.$store.state.config.user.id) === 520) || (parseInt(this.$store.state.config.user.id) === 5) || (parseInt(this.$store.state.config.user.id) === 1842))) ? _c('tooltip', {
    attrs: {
      "label": "Confirm Checked",
      "type": "default",
      "placement": "right"
    }
  }, [_c('a', {
    staticClass: "button button-table is-small",
    on: {
      "click": function($event) {
        return _vm.confirmCheck()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])]) : _vm._e()] : [_c('a', {
    staticClass: "button is-danger button-table is-small",
    on: {
      "click": function($event) {
        return _vm.newOccurrence()
      }
    }
  }, [_vm._v("\n      NEW TICKET\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "button button-table is-small",
    on: {
      "click": _vm.url
    }
  }, [_vm._v("\n      VIEW BOOKING\n    ")])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4860e68a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/services/ServiceTableButtons.vue
// module id = 1125
// module chunks = 39